import { IApplicationState } from '../../types/redux';

export const getNewbuildingPromoSnippetTitle = (state: IApplicationState) =>
  state.offersData.newbuildingPromoSnippet?.newbuilding?.displayName ||
  state.offersData.newbuildingPromoSnippet?.newbuilding?.name ||
  '';
